import LocalAPI from 'utils/LocalAPI';
import { useDraft } from './useDraft';

// Module scope so useDraft sees stable function identities
const transcriptDraftStore = {
  load: (projectID) => LocalAPI.getTranscriptDraft(projectID),
  save: (projectID, draft) => LocalAPI.saveTranscriptDraft(projectID, draft.name, draft.description),
  clear: (projectID) => LocalAPI.clearTranscriptDraft(projectID)
};

export function useTranscriptDraft(projectID) {
  const { value, update, clearDraft } = useDraft(projectID, transcriptDraftStore);

  const handleNameChange = (event) => {
    update({ ...value, name: event.target.value });
  };

  const handleDescriptionChange = (event) => {
    update({ ...value, description: event.target.value });
  };

  return {
    transcriptName: value.name,
    transcriptDescription: value.description,
    handleNameChange,
    handleDescriptionChange,
    clearDraft
  };
}
